'use client';

import { ADPOPCORN_SSP_MODULE } from '@/modules/wello-app';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

//* WEL-5277: 애드팝콘 콘솔 발급 지면 ID — 포맷 × 플랫폼(안드/아이폰).
//* 리워드영상=30초(광고 보고 행운권+1)·전면영상=5초(열기 전 광고).
const ADPOPCORN_SSP_PLACEMENT_ID = {
  [ADPOPCORN_SSP_MODULE.REWARD_VIDEO]: {
    android: 'cdmtiYalkvbwtcq',
    ios: 'tq921bPZIMI511z',
  },
  [ADPOPCORN_SSP_MODULE.INTERSTITIAL_VIDEO]: {
    android: '5Hw4MWLghlKYDL3',
    ios: 'vVhL2uGYWIGGw5e',
  },
} as const;

type AdpopcornSspPlacementFormat = keyof typeof ADPOPCORN_SSP_PLACEMENT_ID;

//* 포맷 × osType으로 지면 ID를 고른다. 비앱 환경은 게이트·앱 브릿지에서 걸러진다.
export const useAdpopcornSspPlacementId = (
  format: AdpopcornSspPlacementFormat,
) => {
  const osType = useDeviceInfoStore((state) => state.osType);
  const placementIdByOs = ADPOPCORN_SSP_PLACEMENT_ID[format];

  return osType === 'ios' ? placementIdByOs.ios : placementIdByOs.android;
};
